import { useCallback, useEffect, useRef } from 'react';

/**
 * Defer dialog open until the next animation frame so a closing Actions
 * dropdown releases its body pointer-events lock first. Without this, stacked
 * modals can leave the page unclickable.
 */
export function useDeferredDialogOpener() {
  const framesRef = useRef<Map<string, number>>(new Map());

  useEffect(() => {
    return () => {
      for (const frameId of framesRef.current.values()) {
        cancelAnimationFrame(frameId);
      }
      framesRef.current.clear();
    };
  }, []);

  return useCallback((key: string, open: () => void) => {
    const previous = framesRef.current.get(key);
    if (previous !== undefined) {
      cancelAnimationFrame(previous);
    }
    const frameId = requestAnimationFrame(() => {
      framesRef.current.delete(key);
      open();
    });
    framesRef.current.set(key, frameId);
  }, []);
}
